import { render, staticRenderFns } from "./odeme_al.vue?vue&type=template&id=3cccc8c2&scoped=true&"
import script from "./odeme_al.vue?vue&type=script&lang=js&"
export * from "./odeme_al.vue?vue&type=script&lang=js&"
import style0 from "./odeme_al.vue?vue&type=style&index=0&id=3cccc8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cccc8c2",
  null
  
)

export default component.exports